export default __webpack_public_path__ + "static/media/GuidingSouls6.b478f323.png";